"use client";

import React, {useEffect, useState} from "react";
import { SDialogFC, SDialogProps } from "@/Master/SDialogFC/SDialogFC";
import styles from "./PwaGuideDialog.module.css";
import {useDialogMethods} from "@/Master/SDialogFC/useDialogMethods";
import KitPwa, {PwaMsgType, PwaStatus} from "@/Master/PWA/KitPwa";
import {hideForceLoading, showForceLoading} from "@/app/_dialogs/LoadingForceDialog/LoadingForceDialogFC";
import EventManager from "@/Fwk/EventManager";
import Util from "@/Master/Util";
import UtilBrowser from "@/Master/UtilBrowser";
import {masterEvent} from "@/Master/Const/MasterEvent";
import DataMgr from "@/Fwk/DataMgr";
import {fwkConst} from "@/Fwk/FwkConst";
import {useAppSelector} from "@/app/storeHooks";
import {selectUserInfo} from "@/app/userSlice";
type PwaMsgTypeKey = keyof typeof PwaMsgType;

/**
 * PWA 消息类型
 */
type PwaMsgTypeValue = typeof PwaMsgType[PwaMsgTypeKey];
type buttonType = SDialogProps['buttons']
interface ShortcutDialogProps extends SDialogProps {
}

//新手首充值礼包
export const PwaGuideDialogFC: React.FC<ShortcutDialogProps> = (props) => {
    const { fcKey,  onClose } = props;
    const userInfo  = useAppSelector(selectUserInfo);
    const {closeDialog} = useDialogMethods(fcKey);
    const [isShowClaimReward, setShowClaimReward] = useState(false)
    const [isShowReward, setShowReward] = useState(true)

    const [buttons,setButtons] = useState<buttonType>([{ label: "Add Now", onClick: () => install(!userInfo.isAddDesktopOpen), style: "greenBtn" },])
    // 添加事件监听
    useEffect(() => {
        // const storageStatus = DataMgr.getStorage(fwkConst.PWA_STATUS) as any | null;
        if (KitPwa.isPlayPwa){
            setButtons([{ label: "Already added", onClick: () => {}, style: "blueBtn" }])
            setShowReward(false)

        }else{
            const status = DataMgr.getStorage(fwkConst.PWA_STATUS)

            switch (status) {
                case PwaStatus.Installed:
                case PwaStatus.InUse:
                case PwaStatus.Update:
                    setShowReward(false)

                    break;
                default:
                    userInfo.addDesktopOpen?setShowReward(false):setShowReward(true)


            }
        }



        EventManager.addEventListener(PwaMsgType.onInstallSuccess, onAcceptInstall);
        EventManager.addEventListener(PwaMsgType.onInitInstalled, onInitInstalled)
        EventManager.addEventListener(PwaMsgType.onInstallFail, onInstallFail)
        EventManager.addEventListener(PwaMsgType.onNotAcceptInstall, onNotAcceptInstall)
        EventManager.addEventListener(masterEvent.onVisibilitychangeShow, onVisibilitychangeShow);


        // 组件卸载时移除事件监听
        return () => {
            EventManager.removeEventListener(PwaMsgType.onInstallSuccess, onAcceptInstall);
            EventManager.removeEventListener(PwaMsgType.onInitInstalled, onInitInstalled);

            EventManager.removeEventListener(PwaMsgType.onInstallFail, onInstallFail);
            EventManager.removeEventListener(PwaMsgType.onNotAcceptInstall, onNotAcceptInstall);
            EventManager.removeEventListener(masterEvent.onVisibilitychangeShow, onVisibilitychangeShow);



        };
    }, []);
    // 未满足可安装条件，安装失败
    const onInstallFail = () =>{
        if (Util.isLog) {
            console.log('shortcutDialog', `==>onInstallFail`)
        }
        showForceLoading();
        setButtons([{ label: "Preparing, please wait...", onClick: () => {}, style: "blueBtn" }])
        setTimeout(()=>{
            hideForceLoading()
            setButtons([{ label: "Click to install", onClick: () => {KitPwa.installPWA(!userInfo.isAddDesktopOpen)}, style: "greenBtn" }])

        },10000)
        //
    }
    const onNotAcceptInstall = ()=>{
        if (Util.isLog) {
            console.log('shortcutDialog', `==>onNotAcceptInstall`)
        }
    }
    const onInitInstalled = () =>{
        if (Util.isLog) {
            console.log('shortcutDialog', `==>onInitInstalled`)
        }
    }
    const onAcceptInstall = (event: any) => {
        if (Util.isLog) {
            console.log('shortcutDialog==onAcceptInstall', event.detail)
            console.log('shortcutDialog==isPlayPwa==isDesktop', KitPwa.isPlayPwa && UtilBrowser.isDesktop)
        }
        // setShowClaimReward(event.detail.isReward)
        // if (Util.isLog){
        //     console.log('event',event.detail)
        // }
        // KitPwa.setPwaStatus(PwaStatus.Installed)
        // //桌面pwa由page里的回调处理
        if (KitPwa.isPlayPwa && UtilBrowser.isDesktop) {
                return
        }
        //android 弹窗按钮变化逻辑
        setButtons([
            { label: "installing...", onClick: () => {}, style: "blueBtn" },
        ]);
        showForceLoading();
        setTimeout(() => {
            if (Util.isLog) {
                console.log('shortcutDialog', `GuidePWA => KitPwa.pwaStatus=${KitPwa.pwaStatus}`)
            }
            hideForceLoading()
            setButtons([
                { label: "Open Play", onClick: () => KitPwa.openPWA(), style: "greenBtn" }
            ]);
        }, 10000);
    }
    const onCLickBtn = ()=>{
        onClose?.();
        closeDialog();


        // KitPwa.installPWA();
    }
    const install = (isShowReward: Boolean)=> {
        const isShowGuide = !KitPwa.isPlayPwa && (Util.isIOS || UtilBrowser.isSafari);
        if(isShowGuide){
            EventManager.dispatchEvent(PwaMsgType.onIOS as PwaMsgTypeValue)
            return
        }

        //测试获取101奖励接口
        // RewardApply.Instance.RequestRewardApply(RewardSource.AddDesktop, (data) => {
        //     const detail = {
        //         isReward: data.code === 200,
        //     }
        //     if (Util.isLog) {
        //         console.log(RewardApply.tag + 'data', data)
        //         console.log(RewardApply.tag + 'detail', detail)
        //     }
        // })
        KitPwa.installPWA(!userInfo.isAddDesktopOpen);

    }
    const onVisibilitychangeShow = ()=>{

        // if (KitPwa.isPlayPwa && UtilBrowser.isDesktop) {
        //     setTimeout(()=>{
        //
        //         if(Util.isLog){
        //             console.log('onVisibilitychangeShow','KitPwa.isPlayPwa && UtilBrowser.isDesktop:'+KitPwa.isPlayPwa && UtilBrowser.isDesktop)
        //             console.log('onVisibilitychangeShow','isShowClaimReward'+isShowClaimReward)
        //         }
        //         if(isShowClaimReward){
        //             SDialogManagerFC.openDialog(RewardDialogFC,{
        //                 fcKey:SDialogManagerFC.getFCKey(RewardDialogFC),
        //                 gcCount:0,
        //                 scCount:4,
        //                 onClose:()=>{
        //                     KitPwa.openPWA();
        //                 }
        //             })
        //         }else{
        //             // KitPwa.openPWA();
        //         }
        //     },2000)
        //
        //     return;
        // }
    }

    return (
        <SDialogFC
            fcKey={fcKey}
            mode="Center"
            title=""
            buttons={buttons}
            onClose={onCLickBtn}
        >
            <div className={styles.container}>
                <img className={`${styles.money} ${styles.money1}`} src="/img/shortcut/$_3.webp" alt="Money" />
                <img className={styles.phone} src="/img/shortcut/ico_addtohome.webp" alt="Phone" />
                <img className={styles.circle} src="/img/shortcut/icon.webp" alt="Circle Icon" />
                <img className={`${styles.money} ${styles.money2}`} src="/img/shortcut/$_2.webp" alt="Money" />
                <p>It's so easy! Just add to the home screen! Shortcut to receive!</p>
                {!userInfo.addDesktopOpen && <div className={styles.sc_free}>
                    <img className={styles.gold} src="/img/ico_sc.png" alt="Gold Icon"/>
                     {userInfo.addDesktopRewards} SC FREE
                </div>}
            </div>
        </SDialogFC>
    );
};
